export default __webpack_public_path__ + "static/media/Home.7120adc3.svg";